export default __webpack_public_path__ + "static/circles-b3fcd2fb2bcb3bcc4de5a8c21aeedf5c.svg";